import Vue from 'vue'
import { setTitle, setGlobalData, getPubData } from '../lib/js/utils'
import { dpubComps } from '@/components/dpub-comps'


const compListMap = {}
let compTotalNum = 0
let loadedCompNum = 0
let compLoadedResolve = undefined
let loadedCompMap = {}


function loadUtLaunchUiComp (compName) {
  if (compListMap[compName]) return
  compTotalNum++
  const tempName = compName.split('Utlaunch')[1]
  const name = tempName.replace(/([a-zA-Z])([A-Z])/g, '$1-$2').toLowerCase()
  import(/* webpackChunkName: "ut-launch-ui-" */`../../node_modules/@didi/ut-launch-ui/dist/${name}/h5/index.css`)
  .then(() => {})
  import(/* webpackChunkName: "ut-launch-ui-" */`../../node_modules/@didi/ut-launch-ui/dist/${name}/h5/index.js`).then((data) => {
    loadedCompMap = { ...loadedCompMap, ...data }
    compListMap[compName] = true
    loadedCompNum++
    if (compTotalNum === loadedCompNum) {
      window.store.commit('setAsyncComps', { ...loadedCompMap, ...dpubComps })
      compLoadedResolve()
    }
  })
}

function genAsyncComps (layers) {
  const len = layers.length
  for (let i = 0; i < len; i++) {
    const { type, children } = layers[i]
    if (type.includes('Utlaunch')) {
      loadUtLaunchUiComp(type)
    }
    if (children && children.length) {
      genAsyncComps(children)
    }
  }
}

const actions = {
  // 根据key 查找组件
  getWidgetsByKey () {

  },
  setWidgetProps ({ getters }, { id, props = {} } = {}) {
    // const layer
    if (!id) throw new Error('"id" is required')
    const widget = getters.allLayers[id]
    if (!widget) throw new Error('widget is not in layers')
    Object.keys(props).forEach((key) => {
      Vue.set(widget.props, key, props[key])
    })
  },

  setWidgetVisibility ({ getters, commit }, { id, show } = {}) {
    // const layer
    if (!id) throw new Error('"id" is required')
    const widget = getters.allLayers[id]
    if (!widget) throw new Error('widget is not in layers')
    const editorStatus = {
      ...widget.editorStatus,
      show
    }
    widget.style.display = show ? 'block' : 'none'
    Vue.set(widget, 'editorStatus', editorStatus)
    commit('setPageData', { id, show })
  },
  async setInitData({ commit, state }, data){
    const { isMultiPage, multiPageDataMap } = state
    if (isMultiPage) {
      const currentRouteName = window.router?.currentRoute?.name || 'index'
      if (!data) { data = state.page }
      data.scenes.layers = multiPageDataMap[currentRouteName]
    }
    commit('initPageData', JSON.parse(JSON.stringify(data)))
    commit('initIo')
    commit('setEventTable', data)
    if (!__isServerRender__) {
      const outerTitle = getPubData('outerTitle')
      setTitle(outerTitle || data.title)
      setGlobalData(data)
      return new Promise((resolve) => {
        if (!__isServerRender__) {
          compLoadedResolve = resolve
          genAsyncComps(data.scenes.layers)
          if (compTotalNum === 0) {
            commit('setAsyncComps', dpubComps)
            resolve()
          }
        }
      })
    }
  }
}

export default actions
